import { makeAutoObservable, runInAction } from "mobx";
import { makePersistable } from 'mobx-persist-store';
export default class SupportStore {
    constructor() {
        makeAutoObservable(this);
        makePersistable(this, { name: 'SupportStore', properties: ['faqs', 'faqCategories', 'supports',] });
    }
    faqs = [];
    faqCategories = [];
    supports = [];

    reset = () => {
		this.faqs = [];
        this.faqCategories = [];
        this.supports = [];
	};

    setFaqs = async (faqs) => {
        runInAction(async() => {
            this.faqs = faqs;
        });
    }

    setFaqCategories = async (state) => {
        runInAction(async() => {
            this.faqCategories = state;
        });
    }
    setSupports = async (state) => {
        runInAction(async() => {
            this.supports = state;
        });
    }
}
